<template>
  <div class="main">
    <div class="video">
      <video
        ref="videoTop"
        v-show="!tabShow"
        controls
        autoplay="autoplay"
        muted
        src="/video/about.mp4"
      ></video>
    </div>
    <div class="introduce">
      <div class="title">企业介绍</div>
      <div class="desc">
        格如灵科技成立于2016年，注册于北京，分别在上海 、广州 、武汉、郑州 、长沙 、南昌 、杭州、南京 、重庆、成都 、西安 、兰州 、济南 、青岛、长春 、沈阳等地设立公司及办事处，并在北京、苏州、南昌、 武汉成立研发中心，是国内领先的虚拟现实软硬件研发及推广的高新技术企业，主营业务涵盖教育与文旅板块。
      </div>
      <div class="desc">
        教育方面，以优质教学资源为核心，聚焦职业教育及企业实训，围绕智能制造、旅游管理、畜牧兽医、能源化工、艺术体育等数字教育及行业重点应用领域，提供包括虚拟仿真实训基地、国家级虚拟仿真金课、远程教育实训平台等一体化解决方案。
      </div>
      <div class="desc">
        文旅领域，公司坚持科技驱动，致力于将多技术与文化创意深度融合，赋能文旅业态新体验。业务板块涵盖新景区文旅、新城市文旅等核心领域，提供建设运营一体化解决方案。
      </div>
      <div class="desc">
        截止2024年末 公司已取得220项VR软件著作权及66项专利（包含在审查的16项）连续五年被评为中国虚拟现实50强企业、成功获批博士后科研工作站、北京“专精特新”企业、江西“专精特新”企业、种子独角兽企业，成功实施落地近千个项目案例。
      </div>
    </div>
    <div class="oneStop">
      <div>
        <div class="headline">用创新的教与学服务每个人</div>
        <div class="type">
          <div class="list">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_625685577ec8d/712187856.png"
              alt=""
            />
            <span class="title">我们的使命</span>
            <span class="desc"
              >用创新的教与学<br>服务每个人
            </span>
          </div>
          <div class="list">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_625685583c178/159750107.png"
              alt=""
            />
            <span class="title">我们的愿景</span>
            <span class="desc"
              >成为元宇宙教学实训<br>的领先企业
            </span>
          </div>
          <div class="list">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_62568558e9003/226459578.png"
              alt=""
            />
            <span class="title">我们的价值观</span>
            <span class="desc"
              >坚持以客户为中心，高质量服务每一个客户；拼搏、担当、创新、分享公开透明、承诺兑现</span
            >
          </div>
        </div>
        <img
          src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/other/bigmap.png"
          alt=""
        />
        <span class="site"
          >格如灵科技在南昌、上海、武汉、深圳、重庆、青岛、成都、杭州、西安、
          广州、福州、南京、长沙、吉林、辽宁等15地设立公司</span
        >
        <span></span>
      </div>
    </div>
    <div class="filiale">
      <div class="headline">各地分公司</div>
      <div class="content">
        <div class="list">
          <div class="title">北京公司总部</div>
          <div class="site">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6256855782271/556228042.png"
              alt=""
            />
            <span>朝阳区酒仙桥路甲4号宏源大厦13层</span>
          </div>
        </div>
        <div class="list">
          <div class="title">上海分公司</div>
          <div class="site">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6256855782271/556228042.png"
              alt=""
            />
            <span>闵行区江月路1388号伍信禾丰广场1幢1号楼581单元</span>
          </div>
        </div>
        <div class="list">
          <div class="title">南昌分公司</div>
          <div class="site">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6256855782271/556228042.png"
              alt=""
            />
            <span>红谷滩新区岭口路888号物联网产业创新中心6楼</span>
          </div>
        </div>
        <div class="list">
          <div class="title">成都分公司</div>
          <div class="site">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6256855782271/556228042.png"
              alt=""
            />
            <span>武侯区长益路61号洪都大厦二号楼5层5号</span>
          </div>
        </div>
        <div class="list">
          <div class="title">苏州分公司</div>
          <div class="site">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6256855782271/556228042.png"
              alt=""
            />
            <span>相城区元和街道云泉街15号鑫亿办公空间360室</span>
          </div>
        </div>
        <div class="list">
          <div class="title">武汉分公司</div>
          <div class="site">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6256855782271/556228042.png"
              alt=""
            />
            <span>洪山区光谷大道3号未来之光7栋18层1803室</span>
          </div>
        </div>
        <div class="list">
          <div class="title">西安分公司</div>
          <div class="site">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6256855782271/556228042.png"
              alt=""
            />
            <span>雁塔区沣惠南路18号唐沣国际广场B座0902A室</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.main {
  background: #fff;
  overflow: hidden;
  padding-bottom: 100px;
  .video {
    display: block;
    z-index: 10;
    position: relative;
    background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/backgroundImg/about_video.png);
    background-size: 100% 100%;
    padding: 60px 0;
    width: 100%;
    video {
      width: 1200px;
      height: 675px;
      margin: 0 auto;
      position: relative;
      display: block;
    }
    img {
      width: 100%;
      height: 100%;
      display: none;
    }
  }
  .introduce {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 70px;
    .title {
      font-size: 28px;
      font-weight: 600;
      color: #000000;
      line-height: 40px;
      padding: 69px 0 45px 0;
      text-align: center;
    }
    .desc {
      font-size: 18px;
      font-weight: 400;
      color: #000000;
      line-height: 48px;
      text-align: justify;
      text-indent: 2em;
    }
  }
  .oneStop {
    padding-top: 62px;
    width: 100%;
    background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/backgroundImg/about_ditu.png);
    background-size: 100% 100%;
    padding-bottom: 71px;
    > div {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      .headline {
        font-size: 28px;
        font-weight: 600;
        color: #000000;
        line-height: 40px;
        text-align: center;
      }
      .type {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 74px;
        .list {
          width: 280px;
          img {
            width: 45px;
            margin: 0 auto;
            display: block;
          }
          .title {
            display: block;
            text-align: center;
            font-size: 16px;
            font-weight: 500;
            color: #000000;
            line-height: 22px;
            padding-top: 22px;
            position: relative;
          }
          .title::after {
            content: "";
            position: absolute;
            left: 50%;
            bottom: -14px;
            margin-left: -14px;
            width: 28px;
            height: 4px;
            background: #ef623d;
            box-shadow: 0px 0px 10px -2px rgba(133, 133, 133, 0.66);
            border-radius: 2px;
            opacity: 0.59;
          }
          .desc {
            display: block;
            text-align: center;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 29px;
            padding-top: 22px;
          }
        }
      }
      > img {
        width: 100%;
        margin-top: 75px;
      }
      .site {
        width: 100%;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #7b8596;
        line-height: 25px;
        padding-top: 30px;
        display: block;
      }
    }
  }
  .filiale {
    .headline {
      padding: 70px 0 90px 0;
      font-size: 28px;
      font-weight: 600;
      color: #000000;
      line-height: 40px;
      text-align: center;
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
      .list {
        width: 30%;
        margin-right: 5%;
        margin-bottom: 33px;
        .title {
          font-size: 16px;
          font-weight: 500;
          color: #f27529;
          line-height: 1;
        }
        .site {
          display: flex;
          align-items: center;
          margin-top: 15px;
          img {
            width: 14px;
            margin-right: 6px;
          }
          span {
            font-size: 14px;
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
        }
      }
      .list:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
@media (max-width: 1000px) {
  .main {
    padding-bottom: 0px;
    .video {
      width: 100%;
      height: 422px;
      margin-top: 0;
      img {
        // display: block;
      }
    }
  }
}
</style>
